import { getAltTag } from "@faire/retailer-visitor-shared/features/Marketplace/utils";
import { PRODUCT_TILE_SURFACE_MAP } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/__internal__/common";
import { ProductTileSurfaceContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileSurfaceContext";
import { getValidImageOrPlaceholder } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/getValidImageOrPlaceholder";
import { useValidateImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/useValidateImage";
import { isFastly } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { TelemetryManager } from "@faire/web--source/common/opentelemetry/TelemetryManager";
import { useContext } from "react";
var useClientHooks = function(image) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var validImageHolder = useValidateImage(image);
    var validImage = (image === null || image === void 0 ? void 0 : image.url) && !isFastly(image.url) ? getValidImageOrPlaceholder(validImageHolder) : image;
    return {
        strictLocalize: strictLocalize,
        validImage: validImage
    };
};
export var useProductOnlyProductTileImageProps = function(param) {
    var productToken = param.productToken, brandName = param.brandName, productName = param.productName, image = param.image, showVerticalImagery = param.showVerticalImagery;
    var _TelemetryManager_get_startManagedSpan;
    var productTileSpan = TelemetryManager.get().getManagedSpan((_TelemetryManager_get_startManagedSpan = TelemetryManager.get().startManagedSpan("ProductTile", {
        productToken: productToken
    }, undefined)) !== null && _TelemetryManager_get_startManagedSpan !== void 0 ? _TelemetryManager_get_startManagedSpan : "");
    var imageLoadSpan = TelemetryManager.get().startSpan("ProductTileImage", undefined, productTileSpan !== null && productTileSpan !== void 0 ? productTileSpan : undefined);
    var _useClientHooks = useClientHooks(image), strictLocalize = _useClientHooks.strictLocalize, validImage = _useClientHooks.validImage;
    var productTileSurface = useContext(ProductTileSurfaceContext).productTileSurface;
    return {
        image: validImage,
        showVerticalImagery: showVerticalImagery !== null && showVerticalImagery !== void 0 ? showVerticalImagery : false,
        imageAltText: getAltTag({
            productName: productName,
            pageType: productTileSurface ? PRODUCT_TILE_SURFACE_MAP[productTileSurface] : undefined,
            brandName: brandName
        }, strictLocalize),
        shouldUseLazyImageLoading: false,
        //Client prop
        onLoad: function() {
            return TelemetryManager.get().endSpan(imageLoadSpan);
        }
    };
};
